import { Component, Input } from '@angular/core';
import { MatchDetailsHeaderObject } from '../../model/MatchDetailsHeaderObject';
import { Util } from '../../util/Util';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MatchDetailsHeaderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'match-details-header',
  templateUrl: 'match-details-header.html'
})
export class MatchDetailsHeaderComponent {
  @Input() matchDetailsHeader : MatchDetailsHeaderObject;

  constructor(private translateService: TranslateService) {
    console.log("Match details header");
    console.log("matchDetailsHeader: " + this.matchDetailsHeader);
  }

  ionViewDidEnter() {
  }

  getScore(score: number): string {
    return (score < 0) ? "--" : String(score);
  }

  getMatchProgress(): string {
    return Util.getMatchProgress(this.matchDetailsHeader.matchProgress, this.matchDetailsHeader.startTime, this.matchDetailsHeader.currentMin, this.translateService);
  }

}



// WEBPACK FOOTER //
// ./src/components/match-details-header/match-details-header.ts